import { FC } from 'react';

import { CategoryContentProps } from './types';
import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

const Content: FC<CategoryContentProps> = ({ location }) => (
  <>
    <h2>
      {`CallAPro: We service${location || ' your city'} and surrounding areas. Our experts provide full service repairs, maintenance and installation of most roof types. Call `}
      <TrackedPhoneNumber />
      {' to get a quote started.'}
    </h2>
    <section>
      <h3>Types of Roofs</h3>
      <p>{`Our${location} roofers work with all different types of roofs including:`}</p>
      <ul>
        <li>Asphalt Shingles</li>
        <li>Metal</li>
        <li>Solar Tiles</li>
        <li>Slate</li>
        <li>Clay Tiles</li>
        <li>Concrete Tiles</li>
        <li>Green Roofing</li>
        <li>Rolled Roofing</li>
        <li>Membrane Roofing</li>
        <li>Built-Up Roofing</li>
        <li>Wood Roofing</li>
        <li>Synthetic Composite Shingles</li>
      </ul>
    </section>
    <section>
      <h3>{`Our${location} roofers offer many different services:`}</h3>
      <ul>
        <li>Roof Inspections</li>
        <li>Roof Repair</li>
        <li>Roofing Installation</li>
        <li>Skylight Installation</li>
        <li>Emergency Repairs</li>
        <li>Gutter Cleaning</li>
        <li>Gutter Installation</li>
        <li>Gutter Repair</li>
      </ul>
    </section>
    <section>
      <h3>Quick Turnaround Time:</h3>
      <p>
        {`Our${location} roofers can often replace a roof in as little as one day. Make sure you ask about our turn around time, from repairs to full replacements, our roofers strive to be as fast and efficient as possible.`}
      </p>
      <p>
        {'Call us on '} <TrackedPhoneNumber />
      </p>
    </section>
    <section>
      <h3>Quality Services:</h3>
      <p>{"Being fast and efficient isn't worth much if you don't receive a quality roof. Make sure to ask about our satisfied customers and here what others have had to say."}</p>
      <p>
        {'Call us on '} <TrackedPhoneNumber />
      </p>
    </section>
  </>
);

export default Content;
